import script from "./HighlightBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./HighlightBox.vue?vue&type=script&setup=true&lang=ts"

import "./HighlightBox.vue?vue&type=style&index=0&id=e4218f2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e4218f2e"]])

export default __exports__